import React, { Component } from "react";
import {
  profile,
  GET,
  alert,
  loading,
  tokens,
  twofa,
  format_date,
  toFixed,
  total,
  linkRole,
} from "./CustomComponent.js";
import { Navbar, Nav } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import LOGO from "../assets/images/logo192.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      user_profile: profile
    };
  }
  componentDidMount = async () => {
    let _cart = localStorage.getItem("cart");
    _cart = _cart ? JSON.parse(_cart) : [];
    this.setState({cart: _cart})
    this.GetProfile();
  };
  componentDidUpdate = async () => {
    const { cart} = this.state;
    let _cart = localStorage.getItem("cart");
    _cart = _cart ? JSON.parse(_cart) : [];
    if(_cart.length !== cart.length){
      this.setState({cart: _cart})
    }
  }
  GetProfile = async () => {
    const result = await GET("v1/market/profile");
    if (result?.status) {
      localStorage.setItem("scp-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
      });
    }
  };
  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        "ยืนยัน",
        "คุณต้องการออกจากระบบหรือไม่?",
        "ออกจากระบบ",
        "ยกเลิก",
      )
    ) {
      loading(true);
      let result = await GET("logout", null);
      if (result?.status) {
        const mode = localStorage.getItem("mode") || "light";
        localStorage.clear();
        localStorage.setItem("mode", mode);
        window.location.href = "/";
      }
      loading(false);
    }
  };

  render() {
    const {cart, user_profile} = this.state;
    const initials = (user_profile?.full_name || "ลค").trim().slice(0, 2);
    const navLinks = [
      { label: "หน้าแรก", href: "/main", icon: "\uf015" },
      { label: "สินค้าทั้งหมด", href: "/product", icon: "\uf466" },
      { label: "การซื้อของฉัน", href: "/transaction", icon: "\uf46d" },
      { label: "ช่วยเหลือ", href: "/help", icon: "\uf059" },
    ];
    const currentPath = typeof window !== "undefined" ? window.location.pathname : "";

    return (
      <div className="w-100">
        <div className="zn-navbar w-100 position-fixed" style={{ zIndex: 1000 }}>
          <div className="container h-100 d-flex align-items-center justify-content-between gap-3">
            {/* Brand */}
            <div className="zn-brand d-flex align-items-center pointer" onClick={() => {window.location.href="/main"}}>
              <div className="zn-brand-logo">
                <img alt="Logo" src={LOGO} width={26} height={26}/>
              </div>
              <div className="lh-1">
                <div className="zn-brand-name">ZENITH <span>CARGO</span></div>
                <div className="zn-brand-tag d-none d-md-block">ช้อปง่าย ส่งไว ไว้ใจได้</div>
              </div>
            </div>

            {/* Center links (desktop) */}
            <nav className="zn-nav d-none d-lg-flex align-items-center">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`zn-nav-link${currentPath === link.href ? " active" : ""}`}
                >
                  <span className="icon me-1">{link.icon}</span>{link.label}
                </a>
              ))}
            </nav>

            {/* Right actions */}
            <div className="d-flex align-items-center gap-2 text-start">
              <a className="zn-cart position-relative" href="/cart" aria-label="ตะกร้าสินค้า">
                <span className="icon">{"\uf07a"}</span>
                {cart.length !== 0 && (
                  <span className="zn-cart-badge">{cart.length > 99 ? "99+" : cart.length}</span>
                )}
              </a>
              <Dropdown align="end">
                <Dropdown.Toggle bsPrefix="no-caret" variant="link" id="dropdown-basic" className="p-0 text-decoration-none">
                  <div className="zn-user d-flex align-items-center text-start">
                    <span className="zn-user-avatar">{initials}</span>
                    <div className="px-2 d-none d-sm-block">
                      <div className="text-14 fw-bold text-dark text-truncate" style={{ maxWidth: 140 }}>
                        {user_profile?.full_name || "ลูกค้าทั่วไป"}
                      </div>
                      <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                        {user_profile?.phone || "-"}
                      </div>
                    </div>
                    <span className="icon text-secondary ms-1 d-none d-sm-inline" style={{ fontSize: 12 }}>{"\uf078"}</span>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2 zn-dropdown">
                  <div className="px-2 pb-2 mb-1 border-bottom d-sm-none">
                    <div className="text-14 fw-bold">{user_profile?.full_name || "ลูกค้าทั่วไป"}</div>
                    <div className="text-12 text-secondary">{user_profile?.phone || "-"}</div>
                  </div>
                  <Dropdown.Item className="rounded-3 px-2" onClick={() => {window.location.href = "/profile";}}>
                    <span className="icon me-2">{"\uf007"}</span>บัญชีของฉัน
                  </Dropdown.Item>
                  <Dropdown.Item className="d-block d-lg-none rounded-3 px-2" onClick={() => {window.location.href = "/address";}}>
                    <span className="icon me-2">{"\uf3c5"}</span>ที่อยู่ของฉัน
                  </Dropdown.Item>
                  <Dropdown.Item className="d-block d-lg-none rounded-3 px-2" onClick={() => {window.location.href = "/change-password";}}>
                    <span className="icon me-2">{"\uf023"}</span>เปลี่ยนรหัสผ่าน
                  </Dropdown.Item>
                  <Dropdown.Item className="rounded-3 px-2" onClick={() => {window.location.href = "/transaction";}}>
                    <span className="icon me-2">{"\uf46d"}</span>การซื้อของฉัน
                  </Dropdown.Item>
                  <Dropdown.Item className="d-block d-lg-none rounded-3 px-2" onClick={() => {window.location.href = "/help";}}>
                    <span className="icon me-2">{"\uf059"}</span>ช่วยเหลือ
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="rounded-3 px-2 text-danger"
                    onClick={async () => {
                      if (
                        await alert(
                          "",
                          "info",
                          "ออกจากระบบ",
                          "ยืนยันการออกจากระบบใช่หรือไม่?",
                          "ออกจากระบบ",
                          "ยกเลิก",
                        )
                      ) {
                        localStorage.clear();
                        window.location.href = "/";
                      }
                    }}
                  >
                    <span className="icon me-2">{"\uf2f5"}</span>ออกจากระบบ
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        {/* spacer เท่าความสูง navbar */}
        <div className="zn-navbar-spacer w-100" />
      </div>
    );
  }
}
